import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { makeStyles } from "helpers/StyleHelper";
import useGlobalContext from "hooks/globalData";
import { FormattedMessage as T } from "react-intl";
import { useQuery } from "react-query";
import { RegenerateUserCertificatesRequest } from "services/KnowfullyAdminClient";

type RegenerationDialogProps = {
  open: boolean;
  onClose: () => void;
  userId: string;
};

const useStyles = makeStyles(() => ({
  dialogLoaderSpan: {
    marginLeft: "10px",
  },
}));

const CertificateRegenerationDialog = ({
  open,
  onClose,
  userId,
}: RegenerationDialogProps) => {
  const styles = useStyles();

  const { userCertificateService } = useGlobalContext();

  const regenerateCertificatesQuery = useQuery(
    ["regenerateUserCertificates", userId],
    () =>
      userCertificateService.regenerateUserCertificates(
        RegenerateUserCertificatesRequest.fromJS({
          userId: userId,
        })
      ),
    {
      enabled: open,
    }
  );

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={open}
      onClose={() => !regenerateCertificatesQuery.isLoading && onClose}
    >
      <DialogTitle>
        {regenerateCertificatesQuery.isLoading && (
          <T id="certificatesAreRegenerating" />
        )}
        {regenerateCertificatesQuery.isFetched &&
          !regenerateCertificatesQuery.isError && (
            <T id="certificatesRegenerated" />
          )}
        {regenerateCertificatesQuery.isError && <T id="serverError" />}
      </DialogTitle>
      <DialogContent dividers>
        {regenerateCertificatesQuery.isLoading && (
          <T id="regenerationInProgressText" />
        )}
        {regenerateCertificatesQuery.isFetched &&
          !regenerateCertificatesQuery.isError && (
            <T id="regenerationSuccessText" />
          )}
        {regenerateCertificatesQuery.isError && <T id="tryAgainLater" />}
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          disabled={regenerateCertificatesQuery.isLoading}
          onClick={onClose}
        >
          <T id="closeButton" />

          {regenerateCertificatesQuery.isLoading && (
            <CircularProgress size={16} sx={styles.dialogLoaderSpan} />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CertificateRegenerationDialog;
